// extracted by mini-css-extract-plugin
export default {"numberInputContainer":"qW2rtV"};